import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const ChevronUp = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg xmlns="http://www.w3.org/2000/svg" width={13} height={8} fill="none" viewBox="0 0 13 8" ref={ref} {...props}>
      <path
        fill="currentColor"
        d="M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
ChevronUp.displayName = 'ChevronUp';
export default ChevronUp;
